const paintingServices = [
  {
    id: 1,
    title: "Repainting",
    image: "/assets/painting/Paint-Service2.jpg",
    image2: "/assets/painting/Repainting3.webp",
    image3: "/assets/painting/painting.webp",
    shortDescription: "Bringing vibrant colors back to your walls.",
    description:
      "Our Repainting service is designed to refresh the look of your home or office. Whether you want to change the color or simply restore the existing one, our professional team uses high-quality paints to ensure a long-lasting and smooth finish. We handle all surface preparations, including cleaning and priming, to guarantee the best results. With a wide range of colors and finishes, you can easily transform any room into a stylish and inviting space.",
    description1:
      "We focus on providing a smooth and durable finish by using advanced techniques and premium paints. Our team ensures precise and clean edges, minimizing any mess or overspray. We can also assist with custom color schemes and finishes, offering recommendations based on your space and preferences. Whether you need a single room or an entire property painted, we offer flexible scheduling to fit your needs.",
    description2:
      "In addition to the walls, our service includes repainting trim, doors, and other wooden or metal surfaces. We guarantee a seamless blend with your existing décor. Our eco-friendly paints are safe for both your family and the environment. With years of experience, our team guarantees a transformation that enhances the overall atmosphere and aesthetics of your home or office.",
    benefits: [
      "Restores vibrant colors to your space.",
      "Long-lasting and smooth finish.",
      "Eco-friendly paints for safety.",
      "Custom color schemes and finishes.",
      "Professional and clean application.",
      "Flexible scheduling options available.",
    ],
  },
  {
    id: 2,
    title: "Interior Painting",
    image: "/assets/painting/Interior Painting3.avif",
    image2: "/assets/painting/Interior Painting2.jpeg",
    image3: "/assets/painting/Interior Painting.jpeg",
    shortDescription: "Transform the interiors with fresh, vibrant colors.",
    description:
      "Our Interior Painting service focuses on enhancing the ambiance of your living spaces. We use premium paints and professional techniques to give your interiors a fresh and elegant look. From bedrooms and living rooms to kitchens and offices, our team ensures that every wall and surface is painted to perfection. With a variety of colors and finishes to choose from, we help you create the ideal atmosphere for your home or workplace.",
    description1:
      "Our team takes care of everything, from preparing the walls to cleaning up afterward. We specialize in smooth finishes, clean lines, and minimal disruption to your daily routine. Whether you want a bold statement wall or subtle tones throughout, we can customize the painting process to meet your needs. Our experienced painters take pride in delivering top-quality results with attention to detail.",
    description2:
      "We also offer additional services like painting trim, doors, and ceilings to complete the look. Our eco-friendly paints are safe for pets and children, providing a healthy environment while revitalizing your space. Trust us to deliver a beautiful, lasting finish that will brighten your interiors for years to come.",
    benefits: [
      "Enhances the ambiance of your interiors.",
      "Customizable color options for any style.",
      "Safe, eco-friendly paints for a healthy environment.",
      "Smooth, professional finish.",
      "Affordable and reliable service.",
      "Flexibility in scheduling and timing.",
    ],
  },
  {
    id: 3,
    title: "Exterior Painting",
    image: "/assets/painting/Exterior Painting3.jpg",
    image2: "/assets/painting/Exterior Painting2.webp",
    image3: "/assets/painting/Exterior Painting.jpg",
    shortDescription: "Protect and beautify the exterior of your property.",
    description:
      "Our Exterior Painting service is designed to give your property a fresh, durable look while protecting it from the elements. We use high-quality, weather-resistant paints that withstand harsh conditions, ensuring that your home or building maintains its beauty for years. Our team handles all aspects of the job, from surface cleaning to priming and painting, providing a flawless finish that enhances your property's curb appeal.",
    description1:
      "Whether you're looking to repaint your entire home or just touch up the exterior, we offer flexible solutions tailored to your needs. Our professional team works efficiently and ensures minimal disruption, delivering a high-quality finish that can withstand the test of time. We specialize in both residential and commercial exterior painting, providing a reliable service you can count on.",
    description2:
      "Our service also includes painting fences, doors, windows, and other outdoor surfaces to match your exterior décor. We use eco-friendly paints that are safe for your family and the environment. With our expertise and attention to detail, we guarantee a smooth and lasting finish that enhances the exterior of your property.",
    benefits: [
      "Durable and weather-resistant finish.",
      "Enhances curb appeal and property value.",
      "Eco-friendly and safe paints.",
      "Professional and efficient service.",
      "Flexible and customizable options.",
      "Protects your property from the elements.",
    ],
  },
  {
    id: 4,
    title: "Waterproofing",
    image: "/assets/painting/Waterproofing3.png",
    image2: "/assets/painting/Waterproofing.webp",
    image3: "/assets/painting/Waterproofing2.jpg",
    shortDescription:
      "Prevent water damage with effective waterproofing solutions.",
    description:
      "Our Waterproofing service is designed to safeguard your property from water damage, leaks, and moisture buildup. We offer a range of advanced techniques to protect both the interior and exterior of your home, including foundations, walls, and roofs. Our team uses high-quality, waterproof coatings and sealants to create a protective barrier that keeps water out and ensures the longevity of your property.",
    description1:
      "We specialize in both residential and commercial waterproofing, providing customized solutions for each property. Our team begins with a thorough assessment of your property to identify potential areas of water intrusion. We then apply appropriate waterproofing materials and techniques to prevent leaks and moisture buildup, ensuring a dry and safe environment.",
    description2:
      "Our waterproofing services also extend to basements, crawl spaces, and other high-risk areas. By using eco-friendly, non-toxic materials, we ensure that your property remains safe for your family and pets. With our expertise, we guarantee effective and long-lasting waterproofing solutions that protect your property from water damage for years to come.",
    benefits: [
      "Prevents water damage and leaks.",
      "Protects foundations, walls, and roofs.",
      "Eco-friendly materials for safety.",
      "Long-lasting and effective solutions.",
      "Customizable for residential and commercial properties.",
      "Expert assessment and application.",
    ],
  },
  {
    id: 5,
    title: "Grouting",
    image: "/assets/painting/Grouting.webp",
    image2: "/assets/painting/Grouting2.jpeg",
    image3: "/assets/painting/Grouting3.webp",
    shortDescription:
      "Restore the integrity and aesthetic of your tiled surfaces.",
    description:
      "Our Grouting service is designed to restore and enhance the appearance of your tiled floors, walls, and surfaces. Over time, grout can become dirty, cracked, or discolored, but with our expert service, we bring back its original look and strength. Whether it's cleaning and resealing existing grout or replacing old grout, our team provides high-quality solutions for any grouting needs.",
    description1:
      "We use premium grout materials that are durable and resistant to stains, moisture, and mold. Our team ensures that the grouting process is done with precision, leaving your surfaces looking flawless. From bathroom tiles to kitchen backsplashes, we specialize in all types of grouting services, providing both aesthetic and functional benefits to your space.",
    description2:
      "Our grouting services also include re-grouting areas that have suffered from wear and tear, ensuring a long-lasting and seamless finish. We take pride in our attention to detail and offer a reliable, affordable solution for restoring your tiled surfaces to their best condition.",
    benefits: [
      "Restores the look and integrity of your tiled surfaces.",
      "Prevents moisture and mold buildup.",
      "Uses premium, durable grout materials.",
      "Works for all types of tiles and surfaces.",
      "Affordable and professional service.",
      "Available for residential and commercial properties.",
    ],
  },
  {
    id: 6,
    title: "Wood Polishing",
    image: "/assets/painting/Wood Polishing3.jpg",
    image2: "/assets/painting/Wood Polishing2.jpg",
    image3: "/assets/painting/Wood Polishing.jpg",
    shortDescription: "Bring back the natural beauty of your wooden surfaces.",
    description:
      "Our Wood Polishing service is designed to restore the elegance and shine of your wooden furniture, flooring, and surfaces. We use high-quality wood polish and professional techniques to ensure a flawless finish. Whether it's a delicate antique piece or a modern wooden installation, our team carefully enhances the wood's natural texture and color, leaving it looking new and vibrant.",
    description1:
      "We specialize in polishing all types of wooden surfaces, including tables, chairs, cabinets, floors, and more. Our team uses eco-friendly, non-toxic polishes that are safe for your family and pets. With our professional wood polishing service, your wooden furniture will have a rich, long-lasting shine that adds warmth and sophistication to any room.",
    description2:
      "Our service also includes repairing any minor scratches or imperfections in the wood before polishing, ensuring a smooth and even surface. We offer both matte and glossy finishes, allowing you to choose the look that best suits your space. With years of experience, we guarantee exceptional results that will keep your wood surfaces looking stunning for years.",
    benefits: [
      "Restores the natural beauty of wood.",
      "Safe and eco-friendly polishing materials.",
      "Enhances shine and texture.",
      "Repairs minor scratches and imperfections.",
      "Professional and reliable service.",
      "Customizable finishes for different looks.",
    ],
  },
];

export default paintingServices;
